export default {
  pt:{
    faculdade: "Selecione a Faculdade ou Escola",
    curso: "Selecione o curso",
    testemunhos: "Testemunhos",
    opiniao:"A opinião dos nossos alunos",
    vermais: "Ver Mais testemunhos",
    pagcurso: "Ver página de curso",
    perguntas:{
      1: "1. Qual o seu percurso profissional após conclusão do curso?",
      2: "2. Que aspectos da sua formação académica foram relevantes para o exercício da sua profissão?",
      3: "3. A quem recomendaria o seu curso?",
      4: "4. Porquê a Universidade da Madeira?",
    }
  },
  en: {
    faculdade: "Choose the faculty or school",
    curso: "Choose the degree",
    testemunhos: "Testimonials",
    opiniao:"Our Student's opinion",
    vermais: "See more testemonials",
    pagcurso: "Go to degree page",
    perguntas:{
      1: "1. What has been your career path after completing the course?",
      2: "2. Which aspects of your academic training were relevant to your profession?",
      3: "3. Who would you recommend your course to?",
      4: "4. Why the University of Madeira?",
    }
  }
}